// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const notEvaluatedAssetsOutShapeDefault = `not_evaluated`;

export const NotEvaluatedAssetsOut = zod.object({
  "shape": zod.literal("not_evaluated").default(notEvaluatedAssetsOutShapeDefault)
});

export type NotEvaluatedAssetsOut = zod.input<typeof NotEvaluatedAssetsOut>;
export type NotEvaluatedAssetsOutOutput = zod.output<typeof NotEvaluatedAssetsOut>;
